// Copyright (c) 2016 Deere & Company

import './date-range-picker.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import WarrantyDateRangePicker from '../../warranty-date-range-picker/warranty-date-range-picker';
import {translate} from '../../../services/translation-service';

const FacetsDateRangePickerControlled = props => {

    const accordionBody = (
        <WarrantyDateRangePicker
            dateRange={props.dateRange}
            maxDate={props.maxDate}
            minDate={props.minDate}
            onDateChange={props.onChange}
        />
    );

    return (
        <Accordion
            accordionId='date-range-picker-accordion'
            body={accordionBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={translate(props.title)}
        />
    );

};

FacetsDateRangePickerControlled.displayName = 'FacetsDateRangePickerControlled';
FacetsDateRangePickerControlled.propTypes = {
    dateRange: PropTypes.instanceOf(DateRange),
    isExpanded: PropTypes.bool.isRequired,
    maxDate: PropTypes.number,
    minDate: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
};

export default FacetsDateRangePickerControlled;



// WEBPACK FOOTER //
// ./src/shared/components/facets/date-range-picker/controlled.js